import { SettingsBuildingsList } from './settings-buildings-list';
import { SettingsBuildingClasses } from './building-classes/settings-building-classes';

interface SettingsBuildingsRealDatamodel {
  buildingId?: number;
}

export const SettingsBuildings: React.FC<SettingsBuildingsRealDatamodel> = ({
  buildingId,
}) => {
  if (buildingId !== undefined) {
    return <SettingsBuildingClasses buildingId={buildingId} />;
  }
  return <SettingsBuildingsList />;
};
